import type { EffectDefinition } from "@/effects/types";

export const CONTRAST_SHADER = "contrast";

function parseIntensity(effectParams: Record<string, unknown>): number {
	const raw = effectParams.intensity;
	return typeof raw === "number" ? raw : Number.parseFloat(String(raw));
}

/** intensity in [-100, 100], 0 = no change. Mapped to a contrast factor in [0, 2] around the
 * 0.5 midpoint (matches the WGSL shader in rust/crates/effects/src/shaders/contrast.wgsl). */
export function intensityToContrastFactor(intensity: number): number {
	return 1 + intensity / 100;
}

export const contrastEffectDefinition: EffectDefinition = {
	type: "contrast",
	name: "Контраст",
	keywords: ["contrast", "color", "cinematic"],
	params: [
		{
			key: "intensity",
			label: "Интенсивность",
			type: "number",
			default: 0,
			min: -100,
			max: 100,
			step: 1,
		},
	],
	renderer: {
		passes: [
			{
				shader: CONTRAST_SHADER,
				uniforms: ({ effectParams }) => ({
					u_amount: intensityToContrastFactor(parseIntensity(effectParams)),
				}),
			},
		],
	},
};
